import styled from 'styled-components';
import { Button, Layout } from 'antd';
import { ThemeList } from 'store/ducks/globalTypes';
import { IThemeSelectorProps } from 'components/ThemeSelector/ThemeSelector';
import { variablesList } from 'constants/variablesList';
import { Link } from 'react-router-dom';

interface SidebarProps {
  open: boolean;
}

interface OverlayProps {
  show: boolean;
}

interface SectionProps {
  section: string;
  token?: any;
}

export const Container = styled('div')`
  padding: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
`;

export const Section = styled('div')<SectionProps>`
  padding: 0px 16px;
  margin: 40px 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 100%;
    border-radius: 4px;

    background: ${({ section, token }) => {
      if (section.includes('Data')) return token?.colorPrimaryBgHover;
      if (section.includes('Reporting')) return token?.colorPrimary;
      if (section.includes('Access')) return token?.colorPrimaryBgHover;
      return '#e5e7eb';
    }};
  }
`;

export const SectionTitle = styled('h2')<{ token: any }>`
  font-weight: 900;
  text-align: center;
  margin: 0;
  color: ${({ token }) => token.colorPrimaryBgHover} !important;
`;

export const List = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 16px;

  @media (max-width: 600px) {
    gap: 12px;
  }
`;

export const CardLine = styled(Link)<IThemeSelectorProps>`
  display: flex;
  align-items: center;
  background: linear-gradient(
    307deg,
    ${(props) => variablesList[props.theme as ThemeList].defaultTabBg} 90%,
    ${(props) => variablesList[props.theme as ThemeList].tabSelected} 95%
  );
  border-radius: 12px;
  padding: 16px 24px;
  text-decoration: none;
  box-shadow: rgba(0, 0, 0, 0.6) 5px 5px 12px;
  transition: all 0.2s ease;
  border-radius: 4px;

  &:hover {
    background-color: #eef3fa;
    transform: translateX(4px);
  }

  @media (max-width: 600px) {
    padding: 12px 16px;
  }
`;

export const LineIcon = styled('div')<{ token: any }>`
  font-size: 24px;
  color: ${({ token }) => token.mainColor};
  margin-right: 16px;

  @media (max-width: 600px) {
    font-size: 20px;
    margin-right: 12px;
  }
`;

export const LineText = styled('span')`
  font-size: 1rem;
  font-weight: 500;

  @media (max-width: 600px) {
    font-size: 0.95rem;
  }
`;

export const StyledButton = styled(Button)`
  min-width: 150px;
  width: 150px;
  display: flex;
  align-self: flex-end;
  margin-right: 23px;
`;

export const SignUpContainer = styled('div')`
  text-align: end;
  padding-right: 24px;

  button {
    margin-left: 10px;
  }
`;

export const WorkingAreaButtonData = styled.div<{ token: any }>`
  display: flex;
  margin: 11px 24px;
  gap: 10px;
  position: relative;
  flex-direction: column;
  width: fit-content;
  position: absolute;
  right: 100px;

  @media (max-width: 1640px) {
    top: 54px;
  }

  @media (max-width: 900px) {
    flex-direction: row;
  }

  @media (max-width: 768px) {
    right: 0;
    margin-top: 53px;
  }

  @media (max-width: 400px) {
    flex-direction: column;
  }

  button {
    background: ${({ token }) => token.actionButtons};

    &:hover {
      background-color: ${({ token }) => token.actionButtonsHover} !important;
    }
  }

  div {
    display: flex;
    gap: 15px;
  }
`;

export const Sidebar = styled.div<SidebarProps>`
  position: fixed;
  top: 0;
  height: 100vh;
  background: white;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
  padding: 20px;
  transition: transform 0.3s ease-in-out;
  transform: ${({ open }) => (open ? 'translateX(20px)' : 'translateX(110%)')};
  z-index: 1000;
`;

export const Overlay = styled.div<OverlayProps>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
`;

export const WorkingAreaButton = styled.div<{ token: any }>`
  display: flex;
  margin: 0 24px;
  justify-content: end;
  gap: 20px;
  position: relative;
  top: -50px;

  @media (max-width: 1640px) {
    top: 10px;
  }

  button {
    background: ${({ token }) => token.actionButtons};
    width: 193px;
    white-space: pre-wrap;

    &:hover {
      background-color: ${({ token }) => token.actionButtonsHover} !important;
    }
  }

  div {
    gap: 15px;
  }
`;

export const WorkingLayout = styled(Layout)`
  position: relative;
`;

export const ConsiderModalBtn = styled(Button)`
  z-index: 100;
`;

export const ModalContent = styled('div')`
  line-height: 1.6;
`;
